import type { FaireProductEntity } from "../../entity_types/product";

export const p_w536edwmf5: FaireProductEntity = {
  token: "p_w536edwmf5",
  type: "product",
  name: "Cozy Cable Knit  54x72 Throw Blanket- Holiday Gift",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/46095d7c91d4cd115a0939cde26150788bc47ce4068517d9a981775a9c27aeb1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/79dd6c4dc6d120b7ed9f84f57d9271c9ace4c016e87cc7b7247d67b3779b5377.png",
    "https://cdn.faire.com/fastly/d878f1e1c9480ffe622fbba9628e0e5fb863da51047e0ba0ba6fc1f0e333ea29.jpeg",
    "https://cdn.faire.com/fastly/8795931cdfcb69614cde433ea00c7e02db7d62ee83f52564c05b2703d58ec5aa.png",
    "https://cdn.faire.com/fastly/652a25f4335dbb4cb31ab2697d90c058f29df97362e769ff8972a6b49754e81f.jpeg",
    "https://cdn.faire.com/fastly/85968cae5ae9604609c4082f5019e4f7e9e56d254f830a44a5ccee80f279187c.jpeg",
    "https://cdn.faire.com/fastly/40b6da64aba6b01e51486954c6c80aa3bbf1e611365c33c9300356f875ffb70c.png",
    "https://cdn.faire.com/fastly/a41977e602436d31cec84dbea3ce70656636eb15a8ac1672bb5b735d5bdffbd0.jpeg"
  ],
  priceDollars: 65,
  description: "Wrap yourself in cloud-like comfort with our Cable Knit Marshmallow Throw Blanket. Crafted from signature Marshmallow fabric with a classic cable-knit texture, this ultra-soft blanket adds cozy luxury to any space—perfect for holiday gifting, chilly nights, and curling up at home all season long.\n\n\nFabrication:\nCrafted from Softies' signature Cable Knit Marshmallow fabric, this blanket combines timeless cable-knit texture with an ultra-plush feel. The cozy construction delivers warmth and softness while adding an elevated, inviting look to any room.\n\nFeatures:\n● 54\" x 72\"\n● Classic cable-knit texture for a timeless aesthetic\n● Ultra-soft, plush feel for exceptional comfort\n● Versatile design perfect for lounging, layering, or gifting\n\nMaterials & Care:\n● 100% Polyester\n● Machine wash cold with like colors\n● Tumble dry low; do not bleach\n\nBest For:\n● Cozy nights at home\n● Thoughtful gifting occasions\n● Adding warmth and texture to any living space\n",
  tags: [],
  msrpDollars: 140,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:02.284Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
